export default {
    onSelectedImage(state) {
        return state.selectedImage;
    },
    onImageWindowOpenedOrClosed(state) {
        return state.isImageListWindowOpen;
    }
}